import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { EmotionalOpeningSection } from '../components/EmotionalOpeningSection';
import { WhoThisIsForSection } from '../components/WhoThisIsForSection';
import { ChapterTableSection } from '../components/ChapterTableSection';
import { MidPageCtaSection } from '../components/MidPageCtaSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { FormatSpecsSection } from '../components/FormatSpecsSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { FaqSection } from '../components/FaqSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-editorial-bg w-full overflow-x-hidden" data-id="element-161">
      <HeroSection data-id="element-162" />
      <EmotionalOpeningSection data-id="element-163" />
      <WhoThisIsForSection data-id="element-164" />
      <ChapterTableSection data-id="element-165" />
      <MidPageCtaSection data-id="element-166" />
      <ReviewsSection data-id="element-167" />
      <FormatSpecsSection data-id="element-168" />
      <FinalCtaSection data-id="element-169" />
      <FaqSection data-id="element-170" />
      <FooterSection data-id="element-171" />
    </main>;
}